module.exports = __webpack_public_path__ + "assets/img/00089.375d2af4.png";